import { areaOptions } from "../../../../constants/areas";
import { functionOptions } from "../../../../constants/functions";
import { routeOptions } from "../../../../constants/routes";

export const channelOptions = ["mobile", "whatsapp", "teams"];

export const steps = [
  "Add Contact Info",
  "Add Endpoint Info",
  "Retention Policy",
];

export const retentionPolicies = ["default"];

export const fields = [
  {
    name: "Employee Number",
    key: "internalId",
    type: "number",
    placeholder: "Enter Employee Number",
    validation: "required",
  },
  {
    name: "Employee Fullname",
    key: "fullName",
    type: "text",
    placeholder: "Enter Employee Name",
    validation: "required",
  },
  {
    name: "Employee Email Address",
    key: "email",
    type: "email",
    placeholder: "Enter Email Address",
    validation: "required",
  },
  {
    name: "Sentinel Number",
    key: "sentinelNumber",
    type: "number",
    placeholder: "Enter Sentinel Number",
    validation: "not required",
  },
  {
    name: "Competence",
    key: "competence",
    type: "select",
    options: [
      "engineering_supervisor",
      "person_in_charge_of_possession",
      "safe_work_leader_2",
      "senior_person_in_charge_of_possession",
      "controller_of_site_safety",
      "person_in_charge_of_siding",
    ],
    validation: "required",
  },
  {
    name: "Status",
    key: "status",
    type: "select",
    options: [
      "assessment_due",
      "current",
      "to_be_determined",
      "under_action_learning",
    ],
    validation: "required",
  },
  {
    name: "Function",
    key: "function",
    type: "select",
    options: functionOptions,
    validation: "required",
  },
  {
    name: "Route",
    key: "route",
    type: "select",
    options: routeOptions,
    validation: "required",
  },
  {
    name: "Area",
    key: "area",
    type: "select",
    options: areaOptions,
    validation: "required",
  },
  {
    name: "Emp Comp From",
    key: "empCompFrom",
    type: "date",
    validation: "not required",
  },
  {
    name: "Emp Comp Valid Until",
    key: "empCompValidUntil",
    type: "date",
    validation: "not required",
  },
  {
    name: "Supervisor",
    key: "supervisorId",
    type: "select",
    options: [], // To be populated dynamically
    validation: "required",
  },
  {
    name: "Position Name",
    key: "positionName",
    type: "text",
    placeholder: "Enter Position Name",
    validation: "required",
  },
  {
    name: "Cost Centre",
    key: "costCentre",
    type: "text",
    placeholder: "Enter Cost Centre",
    validation: "not required",
  },
  {
    name: "Organisation",
    key: "organisation",
    type: "text",
    placeholder: "Enter Organisation",
    validation: "not required",
  },
  {
    name: "Supervisor MVR Role",
    key: "supervisorMvrRole",
    type: "text",
    placeholder: "Enter Supervisor MVR Role",
    validation: "not required",
  },
];
